import { render } from "./adaptive.vue?vue&type=template&id=8d9f9a6e&ts=true"
import script from "./adaptive.vue?vue&type=script&lang=ts"
export * from "./adaptive.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__